// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multi-content[data-v-aeb026de],.multi-title[data-v-aeb026de]{text-align:left}.multi-content[data-v-aeb026de]{display:flex;flex-direction:column}.multi-checkbox[data-v-aeb026de]{padding-top:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
